module.exports = __webpack_public_path__ + "media/images/icons/flags/GA-31975863bcb0ed3adb8a004c5680662f.svg";